/**
 * Used by Vue Router and build process
 **/

module.exports = {
  basePath: 'access',
  pages: {
    index: '/index.html',
    auth: '/access.html',
    register: '/register.html',
    reset: '/reset-password.html',
    signin: '/signinhub.html',
    changepass: '/change-password.html',
  },
};



// WEBPACK FOOTER //
// ./src/router/aliases.js